// src/components/wallet/WalletWidget.jsx
import React, { useState, useEffect, useCallback } from 'react';
import { BoltIcon, BanknotesIcon } from '@heroicons/react/24/outline';
import apiClient from '../../lib/apiClient';
import './wallet.css';

const PACKS = [
  { credits: 10,  price: 'R$ 9,90',  label: 'Starter',  highlight: false },
  { credits: 50,  price: 'R$ 39,90', label: 'Pro',       highlight: true  },
  { credits: 150, price: 'R$ 99,90', label: 'Business',  highlight: false },
];

export default function WalletWidget({ compact = false, onBalanceChange }) {
  const [wallet, setWallet]   = useState(null);
  const [buying, setBuying]   = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState('');
  const [success, setSuccess] = useState('');

  const load = useCallback(async () => {
    try {
      setLoading(true);
      const r = await apiClient.request('/wallet/balance', { method: 'GET' });
      const d = await r.json();
      if (d.success) {
        setWallet(d.wallet);
        onBalanceChange?.(d.wallet);
      }
    } catch {}
    finally { setLoading(false); }
  }, [onBalanceChange]);

  useEffect(() => { load(); }, [load]);

  const handleBuy = async (pack) => {
    setError(''); setSuccess('');
    try {
      const r = await apiClient.request('/wallet/buy', {
        method: 'POST',
        body: JSON.stringify({ credits: pack.credits }),
      });
      const d = await r.json();
      if (d.success) {
        setSuccess(d.message);
        setWallet(prev => ({ ...prev,
          available_credits: d.available_credits,
          lifetime_purchased: d.lifetime_purchased }));
        onBalanceChange?.({ ...wallet, available_credits: d.available_credits });
        setTimeout(() => setSuccess(''), 3000);
      } else {
        setError(d.message || 'Erro ao comprar créditos');
      }
    } catch { setError('Erro de conexão'); }
  };

  if (compact) {
    return (
      <div className="ww-compact">
        <BoltIcon className="ww-compact__icon icon-sm" />
        <span className="ww-compact__val">{loading ? '…' : (wallet?.available_credits ?? 0)}</span>
        <span className="ww-compact__label">créditos</span>
      </div>
    );
  }

  return (
    <div className="ww">
      <div className="ww__header">
        <span className="ww__title"><BanknotesIcon className="icon-sm icon-inline" />Carteira de Créditos</span>
        <button className="ww__refresh" onClick={load} title="Atualizar">↻</button>
      </div>

      {loading ? (
        <div className="ww__loading">Carregando…</div>
      ) : (
        <div className="ww__balance-row">
          <div className="ww__balance-card">
            <div className="ww__balance-val">{wallet?.available_credits ?? 0}</div>
            <div className="ww__balance-lbl">Disponíveis</div>
          </div>
          <div className="ww__balance-card ww__balance-card--locked">
            <div className="ww__balance-val">{wallet?.locked_credits ?? 0}</div>
            <div className="ww__balance-lbl">Bloqueados</div>
          </div>
          <div className="ww__balance-card ww__balance-card--lifetime">
            <div className="ww__balance-val">{wallet?.lifetime_purchased ?? 0}</div>
            <div className="ww__balance-lbl">Total comprado</div>
          </div>
        </div>
      )}

      {!buying ? (
        <button className="ww__buy-btn" onClick={() => setBuying(true)}>+ Comprar créditos</button>
      ) : (
        <div className="ww__packs">
          <p className="ww__packs-title">Escolha um pacote:</p>
          <div className="ww__packs-grid">
            {PACKS.map(p => (
              <div key={p.credits} className={`ww__pack${p.highlight ? ' ww__pack--highlight' : ''}`}
                onClick={() => handleBuy(p)}>
                {p.highlight && <span className="ww__pack-badge">Popular</span>}
                <div className="ww__pack-credits"><BoltIcon className="icon-xs" />{p.credits}</div>
                <div className="ww__pack-label">{p.label}</div>
                <div className="ww__pack-price">{p.price}</div>
              </div>
            ))}
          </div>
          <button className="ww__cancel" onClick={() => setBuying(false)}>Cancelar</button>
        </div>
      )}

      {success && <div className="ww__success">{success}</div>}
      {error   && <div className="ww__error">{error}</div>}

      <div className="ww__costs">
        <p className="ww__costs-title">Tabela de custos</p>
        <div className="ww__costs-row"><span>Criação IA</span><span><BoltIcon className="icon-xs" />1</span></div>
        <div className="ww__costs-row"><span>Refino Especialista</span><span><BoltIcon className="icon-xs" />3</span></div>
        <div className="ww__costs-row"><span>Setup Campanha Ads</span><span><BoltIcon className="icon-xs" />10</span></div>
      </div>
    </div>
  );
}
